import { Form, Text } from 'react-form';
import { AbconetApi } from '../General/AbconetApi';
import { isNullOrUndefined } from 'util';
var SiteSelector = require('../General/Selectors/SiteSelector').SiteSelector;
var EquipmentSelector = require('../General/Selectors/EquipmentSelector').EquipmentSelector;
var ServiceOrderTypeSelector = require('../General/Selectors/ServiceOrderTypeSelector').ServiceOrderTypeSelector;

export class ServiceEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaved: false,
            isSaving: false,
            submittedValues: this.props.initialState,
            errorMessage: "",
            description: null
        }
    }

    renderHeader() {
        if (this.props.initialState.id <= 0) {
            return <div><i className="icon icon-order lead d-flex justify-content-center"></i><h4 className="text-center"><strong>Book Service</strong></h4></div>;
        }

        return <div><i className="icon icon-order lead d-flex justify-content-center"></i><h4 className="text-center"><strong>Edit Service</strong></h4></div> ;
    }

    setChange(data) {
        this.setState({
            isSaved: false
        });
    }

    submitService(submittedValues) {
        if (isNullOrUndefined(submittedValues.equipment) || submittedValues.equipment === '') {
            alert('Please select equipment');
            return;
        }

        if (isNullOrUndefined(submittedValues.address) || submittedValues.address === '') {
            alert('Please select site');
            return;
        }

        var description = this.state.description + " \n\nSite Contact: " + submittedValues.siteContact + "\nPhone: " + submittedValues.phone;

        submittedValues.problemDescription = description;

        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);

    }

    sendStateToServer() {
        var self = this;
        AbconetApi.post('/api/servicejob/', this.state.submittedValues).then(response => {
            console.log(response);
            self.setState({ isSaved: true, errorMessage: "", isSaving: false });

            if (response.id !== 0) {
                window.location = `/services/${response.id}?serviceJobList=${response.id}`;
            }
        })
            .catch((error) => {
                self.setState({
                    isSaved: true,
                    isSaving: false
                });
            });
    }

    renderSubmittedMessage() {
        if (this.state.isSaved) {
            return (<div className="alert alert-info">Your service has been submitted.</div>);
        }
    }

    getLabelColClassName() {
        if (this.props.miniMode) {
            return 'col-6';
        }

        return 'col-sm-2';
    }

    getValueColClassName() {
        if (this.props.miniMode) {
            return 'col-6';
        }

        return 'pl-0 col-sm-13';
    }

    renderFinishEditingButton() {
        if (this.props.initialState.id === 0) {
            return;
        }

        return <button onClick={this.finishEdit.bind(this)} disabled={!this.state.isSaved} className="btn btn-outline-primary">Finish Editing</button>;
    }

    finishEdit() {
        if (this.props.onFinishEdit) {
            this.props.onFinishEdit(this.state.submittedValues);
        }
    }

    renderCancelButton() {
        if (!this.props.initialState.canEdit && this.props.initialState.id !== 0) {
            return;
        }

        var btnText = 'Cancel';
        var btnClass = 'changes';


        return <button className={"btn btn-outline-primary " + btnClass} disabled={this.state.isSaving} onClick={this.handleCancel.bind(this)}>{btnText}</button>;
    }

    handleCancel(ev) {
        ev.preventDefault();
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    renderSaveButton() {

        if (!this.props.initialState.canEdit && this.props.initialState.id !== 0) {
            return;
        }


        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        if (!this.props.miniMode) {
            btnClass += ' float-right';
        }

        return <button className={"btn btn-primary " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    validateLength(e, length) {
        if (e.target.value.length > length) {
            e.target.value = e.target.value.slice(0, length)
        } else {
            e.target.value;
        }
    }

    setDescription(value) {
        this.setState({
            isSaved: false,
            description: value.target.value          
        });
    }

    renderOrderNumberField() {
        if (this.props.initialState.requiresOrderNumber) {
            return <Text required field="orderNumber" id="orderNumber" className="form-control" />;
        }


        return <Text field="orderNumber" id="orderNumber" className="form-control" />;
    }

    render() {
        var cardClassName = "card-body text-dark";

        return (
            <div>
                {this.renderSubmittedMessage()}
          

                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitService.bind(this)}
                    defaultValues={this.state.submittedValues}>
                    {formApi => {
                        this.formApi = formApi;
                        return (
                            <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                                <fieldset disabled={this.state.canEdit}>                  
                                    <div className={cardClassName, "col-md-8"} style={{ padding: "50px", borderStyle: "solid", borderColor: "#a1c9c9", borderRadius: "7px", marginLeft: "auto", marginRight: "auto" }} >
                                        <div className="col-md-12">
                                        {this.renderHeader()}
                                        <div className="form-group ">
                                            <label htmlFor="address" className={this.getLabelColClassName(), "font-weight-bold"}>Equipment</label>
                                            <div className={this.getValueColClassName()}>
                                                <EquipmentSelector id="equipment" field="equipment" />
                                            </div>
                                        </div>

                                        <div className="form-group ">
                                            <label htmlFor="address" className={this.getLabelColClassName(), "font-weight-bold"}>Site</label>
                                            <div className={this.getValueColClassName()}>
                                                <SiteSelector  field="address" />
                                            </div>
                                        </div>                                 
                                
                                        <div className="form-group ">
                                            <label htmlFor="serviceOrderType" className={this.getLabelColClassName(), "font-weight-bold"}>Service Order Type</label>
                                            <div className={this.getValueColClassName()}>
                                                    <ServiceOrderTypeSelector field="serviceOrderType" />
                                            </div>
                                        </div>

                                        <div className="form-group ">
                                            <label htmlFor="siteContact" className={this.getLabelColClassName(), "font-weight-bold"}>Site Contact</label>
                                            <div className={this.getValueColClassName()}>
                                                    <Text  required field="siteContact" id="siteContact" className="form-control" />
                                            </div>
                                        </div>

                                        <div className="form-group ">
                                            <label htmlFor="phone" className={this.getLabelColClassName(), "font-weight-bold"}>Phone Number</label>
                                            <div className={this.getValueColClassName()}>
                                                    <Text  required field="phone" id="phone" className="form-control" />
                                            </div>
                                        </div>

                                        <div className="form-group ">
                                            <label htmlFor="orderNumber" className={this.getLabelColClassName(), "font-weight-bold"}>PO Number</label>
                                                <div className={this.getValueColClassName()}>
                                                    {this.renderOrderNumberField()}                                                    
                                            </div>
                                        </div>

                                        <div className="form-group ">
                                            <label htmlFor="description" className={this.getLabelColClassName(), "font-weight-bold"}>Description</label>
                                            <div className={this.getValueColClassName()}>
                                                <textarea onChange={this.setDescription.bind(this)} required field="problemDescription" id="problemDescription" className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <br />
                                    <div className="col-md-8 d-flex justify-content-center" style={{ marginLeft: "auto", marginRight: "auto" }}>
                            
                                        <div className="col-6">
                                            {this.renderFinishEditingButton()}
                                        </div>
                                        <div className="col-6">
                                            {this.renderSaveButton()}
                                        </div>
                                
                                    </div>
                                </fieldset>
                            </form>
                        )
                    }}
                </Form>
            </div >
        );
    }

}